module.exports = __webpack_public_path__ + "img/gamcare-colour.d77f8b12.svg";